import { Component, Output, EventEmitter, OnInit } from "@angular/core";
import { CommonProvider } from "../../providers/common/common";

import _ from "lodash";

declare let document: any;

/**
 * Generated class for the LearnEnglishComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "learn-english",
  templateUrl: "learn-english.html",
})
export class LearnEnglishComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  isPlay = false;

  viewMode = "playlist";
  playMode = "repeat";

  public playlists: any = [];
  public playlist = null;
  public selectedItem = null;

  constructor(private common: CommonProvider) {
    this.fetchLearnEnglish();
  }

  ngOnInit() {}

  fetchLearnEnglish() {
    this.common.fetchLearnEnglish().subscribe((resp: any) => {
      this.playlists = resp.data;
    });
  }

  openPlaylist(playlist) {
    playlist.posts = playlist.posts || [];
    this.playlist = playlist;
  }

  play(item) {
    this.isPlay = true;
    this.selectedItem = item;

    setTimeout(() => {
      document.getElementById("MY_VIDEO").addEventListener(
        "ended",
        () => {
          console.log("END MY_VIDEO");

          if (this.playMode === "loop") {
            const index = _.findIndex(
              this.playlist.posts,
              (o) => o.id === this.selectedItem.id
            );

            console.log(this.playlist.posts[index + 1]);

            if (this.playlist.posts[index + 1]) {
              this.selectedItem = this.playlist.posts[index + 1];
            } else if (this.playlist.posts.length) {
              this.selectedItem = this.playlist.posts[0];
            }
          }

          if (this.playMode === "random") {
            const items = _.filter(
              this.playlist.posts,
              (o) => o.id !== this.selectedItem.id
            );
            const item = items[Math.floor(Math.random() * items.length)];
            this.selectedItem = item;
          }

          document.getElementById("MY_VIDEO").currentTime = 0.0;
          document.getElementById("MY_VIDEO").play();
        },
        false
      );
      console.log("START MY_VIDEO");
    }, 800);
  }

  back() {
    this.playlist = null;
    this.selectedItem = null;

    if (this.isPlay) {
      try {
        document.getElementById("MY_VIDEO").currentTime = 0.0;
        document.getElementById("MY_VIDEO").pause();
      } catch ($e) {
        console.log($e);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/learn-english/learn-english.ts